/**
 * @desc 前端-创建调拨单
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.AllocationMasterCreateForPageRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/allocationMaster/createForPage`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
